export const MMB = {
  SPX: {
    symbol: "SPX",
    url: "https://discord.com/api/channels/1016119273502023770/messages",
  },
  SPY: {
    symbol: "SPY",
    url: "https://discord.com/api/channels/1016118824636002305/messages",
  },
  QQQ: {
    symbol: "QQQ",
    url: "https://discord.com/api/channels/1016119354770862081/messages",
  },
  DIA: {
    symbol: "DIA",
    url: "https://discord.com/api/channels/1090008253557112894/messages",
  },
  IWM: {
    symbol: "IWM",
    url: "https://discord.com/api/channels/1090008192639041576/messages",
  },
  AAPL: {
    symbol: "AAPL",
    url: "https://discord.com/api/channels/1016116586156933140/messages",
  },
  AMZN: {
    symbol: "AMZN",
    url: "https://discord.com/api/channels/1016118206202654802/messages",
  },
  TSLA: {
    symbol: "TSLA",
    url: "https://discord.com/api/channels/1008872104629899294/messages",
  },
  GOOG: {
    symbol: "GOOG",
    url: "https://discord.com/api/channels/1016117999784173688/messages",
  },
  MSFT: {
    symbol: "MSFT",
    url: "https://discord.com/api/channels/1016118098581012502/messages",
  },
  NVDA: {
    symbol: "NVDA",
    url: "https://discord.com/api/channels/1026884803397685278/messages",
  },
  META: {
    symbol: "META",
    url: "https://discord.com/api/channels/1169700442717040801/messages",
  },
  PI_SPY: {
    symbol: "PI_SPY",
    url: "https://discord.com/api/channels/1256774429103624232/messages",
  },
  PI_QQQ: {
    symbol: "PI_QQQ",
    url: "https://discord.com/api/channels/1256774963818397860/messages",
  },
};

export const PAGE = {
  BEFORE: "before",
  AFTER: "after",
};

export const TRADING_SERVER_URL = process.env.REACT_APP_API_ENDPOINT;
export const PROXY_DISCORD_URL = `${TRADING_SERVER_URL}/proxy-discord`;
export const MMB_HISTORY_URL = `${TRADING_SERVER_URL}/mmb-history`;
export const CHART_URL = `${TRADING_SERVER_URL}/chart`;
export const LOGIN_URL = `${TRADING_SERVER_URL}/auth/login`;
// One GET for every scheduler switch, one POST to patch any subset of them.
export const CONTROLLER_URL = `${TRADING_SERVER_URL}/controller`;
export const ENERGY_CAPTURE_CONFIG_URL = `${TRADING_SERVER_URL}/settings/energy-capture`;
export const ENERGY_CAPTURE_PREVIEW_URL = `${TRADING_SERVER_URL}/debug/energy-capture`;
export const ORANGE_BAR_PREVIEW_URL = `${TRADING_SERVER_URL}/debug/orange-bar/screenshot`;
export const CHART_CAPTURE_PREVIEW_URL = `${TRADING_SERVER_URL}/debug/chart-capture`;
export const SSE_URL = `${TRADING_SERVER_URL}/events`;
export const FUTUREMAP_PARSE_URL = `${TRADING_SERVER_URL}/futuremap/parse`;
export const MMB_DEPTH_SYNC_URL = `${TRADING_SERVER_URL}/mmb-depth/sync`;
export const MARKET_CALENDAR_URL = `${TRADING_SERVER_URL}/settings/market-calendar`;
export const NGROK_SKIP_HEADER = "ngrok-skip-browser-warning";

export const MMB_HISTORY = ["SPY", "SPX"];
export const ENERGY = ["energy"];

export const ENERGY_COLUMNS = [
  {
    Header: "Time",
    accessor: "timestamp",
  },
  {
    Header: "F-Alpha",
    accessor: "falpha",
  },
  {
    Header: "Alpha",
    accessor: "alpha",
  },
  {
    Header: "Beta",
    accessor: "beta",
  },
  {
    Header: "SD",
    accessor: "sd",
  },
  {
    Header: "Bull Algos",
    accessor: "bullalgos",
  },
  {
    Header: "Bear Algos",
    accessor: "bearalgos",
  },
  {
    Header: "BP",
    accessor: "battleprogram",
  },
  {
    Header: "Dark Pools",
    accessor: "darkpools",
  },
];

export const FORMAT_WEEKDAY_OPTION = {
  timeZone: "America/New_York",
  weekday: "long",
};

export const ENLARGED_IMAGE_TOP_PADDING = 40;
export const ENLARGED_IMAGE_LEFT_PADDING = 80;

export const QUERY_PARAMS = {
  NUM_OF_CHARTS: "numOfCharts",
  PROXY_DISCORD_IMAGE: "proxyDiscordImage",
};

export const MMB_INDEX = {
  MMB1: "mmb1",
  MMB2: "mmb2",
  MMB3: "mmb3",
  MMB4: "mmb4",
  // The two grid layout keeps its own symbol selection so that switching
  // layouts does not clobber the symbols picked in the four grid layout.
  MMB1_TWO_GRID: "mmb1-2grid",
  MMB2_TWO_GRID: "mmb2-2grid",
}

export const NUM_OF_CHARTS = {
  FOUR: "4",
  TWO: "2",
};

// Fired on window when the home layout is changed from the settings menu.
export const NUM_OF_CHARTS_CHANGE_EVENT = "numOfChartsChange";

// Wording and order for the scheduler switches. The list rendered is whatever
// GET /controller reports, not this object: a scheduler added on the server
// still appears here -- labelled by its raw key -- without a UI deploy.
export const SCHEDULER_LABELS = {
  alertPi: "Alert PI",
  futureMapUpdater: "FutureMap Updater",
  chartCapture: "Auto Chart Capture",
  mmbDepth: "Auto MMB Depth Lines",
  energyCapture: "Auto Energy Capture",
  orangeBarAlert: "Orange Bar Alert",
};

export const ENERGY_SYMBOL = {
  SPY: "SPY",
  QQQ: "QQQ",
};
